'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuex = require('vuex');

exports.default = {
  name: "FrameSelections",

  computed: Object.assign({}, (0, _vuex.mapState)({
    frame: function frame(state) {
      return state.prescription.frame;
    },
    options: function options(state) {
      return state.prescription.options;
    },
    totalPrice: function totalPrice(state) {
      return state.prescription.totalPrice;
    }
  }), {
    framePrice: function framePrice() {
      return this.formattedPrice(this.frame.selectedVariant.price);
    },
    currentOptions: function currentOptions() {
      var result = {};

      for (var key in this.options) {
        var cost = this.options[key].cost;
        if (cost > 0 || cost === 'free') {
          result[key] = this.options[key];
        }
      }

      return result;
    }
  }),

  methods: Object.assign({}, (0, _vuex.mapMutations)(['setTotalPrice']), {
    formattedPrice: function formattedPrice(price) {
      return price === 'free' ? '' : 'P' + parseFloat(price / 100).toFixed(2).replace('.00', '');
    },
    updateTotal: function updateTotal() {
      var _this = this;

      var total = 0;
      var framePrice = this.frame.selectedVariant.price;
      var optionsKeys = Object.keys(this.options);

      total += framePrice;
      optionsKeys.map(function (option) {
        return typeof _this.options[option].cost === 'number' ? total += _this.options[option].cost : total += 0;
      });

      this.setTotalPrice(this.formattedPrice(total));
    }
  }),

  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.updateTotal();
    });
  },

  watch: {
    options: {
      deep: true,
      handler: function handler() {
        this.updateTotal();
      }
    }
  }
}; //
//
//
//
//
//
//
//
//
//